import type { UntypedFormControl } from '@angular/forms';

export function invalidSelectedOptionValidator(options: Array<{ value: string | number | null }>) {
  return (control: UntypedFormControl): { invalidSelectedOption: true } | null =>
    !control.value || options.find(option => option.value === control.value)
      ? null
      : { invalidSelectedOption: true };
}
